<template>
  <div class="row mt-4">
    <div class="col-12">
      <div class="card ficha-listado mb-4">
        <div class="px-4 pb-4 card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h6 class="mb-0">{{ $t('panelCliente.actividadTitulo') }}</h6>
              <p class="text-xs opacity-7 mb-0">Total: <b>{{ actividad.length }}</b></p>
            </div>
          </div>

          <div v-if="actividad.length === 0" class="alert alert-secondary text-sm mb-0">
            {{ $t('panelCliente.actividadVacio') }}
          </div>

          <div v-else class="table-responsive">
            <table class="table table-flush table-listado table-empirulada">
              <thead class="thead-light">
                <tr>
                  <th>{{ $t('panelCliente.canal') }}</th>
                  <th>{{ $t('panelCliente.idioma') }}</th>
                  <th>{{ $t('panelCliente.ultimaEntrada') }}</th>
                  <th>{{ $t('panelCliente.ultimaSalida') }}</th>
                  <th class="text-center">{{ $t('panelCliente.reingresos') }}</th>
                  <th class="text-center">{{ $t('panelCliente.activo') }}</th>
                </tr>
              </thead>
              <tbody class="text-sm">
                <tr v-for="a in actividad" :key="a.registro_id">
                  <td>{{ a.canal?.nombre || "-" }}</td>
                  <td>{{ a.idioma || "-" }}</td>
                  <td>{{ fmtFechaHora(a.last_join_at) }}</td>
                  <td>{{ fmtFechaHora(a.last_leave_at) }}</td>
                  <td class="text-center">{{ a.reingresos ?? 0 }}</td>
                  <td class="text-center">
                    <span class="badge-estado" :class="a.activo ? 'badge-ok' : 'badge-muted'">
                      {{ a.activo ? $t('panelCliente.si') : $t('panelCliente.no') }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PanelClienteActividad",
  props: {
    actividad: { type: Array, default: () => [] },
  },
  methods: {
    fmtFechaHora(fechaStr) {
      if (!fechaStr) return "-";
      try {
        const d = new Date(fechaStr);
        if (Number.isNaN(d.getTime())) return fechaStr;
        const locale = this.$i18n?.locale === 'en' ? 'en-GB' : 'es-ES';
        return d.toLocaleString(locale);
      } catch { return fechaStr; }
    },
  },
};
</script>

<style scoped>
.table-empirulada { border-collapse: separate !important; border-spacing: 0 10px; }
.table-empirulada thead th { border: 0 !important; background: var(--q-hover); color: var(--q-text); font-weight: 700; padding: 12px 14px; }
.table-empirulada tbody tr { background: var(--q-card); box-shadow: 0 6px 18px rgba(0,0,0,.06); overflow: hidden; }
.table-empirulada tbody td { border: 0 !important; padding: 12px 14px; vertical-align: middle; }
.table-empirulada > :not(caption) > * > * { border-bottom-width: 0 !important; }
.table-empirulada tbody tr:hover { transform: translateY(-1px); transition: .15s ease; }
.table-empirulada tbody tr td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }
.table-empirulada tbody tr td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }
.table-empirulada thead, .table-empirulada thead tr, .table-empirulada thead th { border-radius: 0 !important; }
.table-empirulada thead th:first-child, .table-empirulada thead th:last-child {
  border-top-left-radius: 0 !important; border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;
}
.table-empirulada thead tr { box-shadow: none !important; background: transparent !important; }

.badge-estado { display: inline-block; padding: 3px 10px; border-radius: 20px; font-size: 11px; font-weight: 700; }
.badge-ok   { background: var(--q-green-soft); color: var(--q-green);  border: 1px solid var(--q-green); }
.badge-muted{ background: var(--q-hover);      color: var(--q-muted);  border: 1px solid var(--q-border-md); }
</style>
